<template>
  <div>
    <!-- hCaptcha -->
    <vue-hcaptcha
      v-if="isHcaptcha && sitekey"
      @verify="handleVerify"
      :sitekey="sitekey"
      ref="hcaptchaRef"
      :size="size"
    ></vue-hcaptcha>

    <!-- Cloudflare Turnstile -->
    <NuxtTurnstile
      v-else-if="isTurnstile && turnstilesitekey"
      ref="turnstileRef"
      v-model="turnstileToken"
      :site-key="turnstilesitekey"
      :options="{ size }"
    />
  </div>
</template>

<script setup>
import { ref, computed, watch } from 'vue';
import VueHcaptcha from '@hcaptcha/vue3-hcaptcha';
import { useWebsiteInfoStore } from '@/stores/website';

const props = defineProps({
  sitekey: {
    type: String,
    default: '',
  },
  size: {
    type: String,
    default: 'invisible',
  },
  mode: {
    type: String,
    default: 'execute', // 'execute' (manual), 'render' (automatic)
  },
});

const emit = defineEmits(['verify', 'error', 'expire']);

const websiteInfoStore = useWebsiteInfoStore();
const website = computed(() => websiteInfoStore.website);

const hcaptchaRef = ref(null);
const turnstileRef = ref(null);
const turnstileToken = ref('');

const isHcaptcha = computed(() => {
  return website.value.captcha_provider === 'hcaptcha';
});

const isTurnstile = computed(() => {
  return (
    !website.value.captcha_provider ||
    website.value.captcha_provider === 'turnstile'
  );
});

const turnstilesitekey = computed(() => {
  return website.value.cf_turnstile_sitekey || '';
});

const handleVerify = (token) => {
  emit('verify', token);
};

const handleError = () => {
  emit('error');
};

const execute = () => {
  if (isHcaptcha.value && hcaptchaRef.value) {
    hcaptchaRef.value.execute();
  } else if (isTurnstile.value && turnstileRef.value) {
    turnstileRef.value.execute();
  }
};

// Watch for turnstile token changes
watch(turnstileToken, (newToken) => {
  if (newToken) {
    handleVerify(newToken);
  }
});

defineExpose({
  execute,
});
</script>
